import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)


import ResetPassword from '../pages/ResetPassword.vue'

const Home = resolve => require(['../pages/Home.vue'], resolve)
const HomeWrapper = resolve => require(['../components/HomeWrapper.vue'], resolve)
const Review = resolve => require(['../pages/Review.vue'], resolve)
const ProductList = resolve => require(['../pages/ProductList.vue'], resolve)
const ProductDetail = resolve => require(['../pages/ProductDetail.vue'], resolve)
const OrderList = resolve => require(['../pages/OrderList.vue'], resolve)
const MyCart = resolve => require(['../pages/MyCart.vue'], resolve)
const Checkout = resolve => require(['../pages/Checkout.vue'], resolve)
const Pay = resolve => require(['../pages/Pay.vue'], resolve)
const SearchResultList = resolve => require(['../pages/SearchResultList.vue'], resolve)
const ReviewSuccess = resolve => require(['../pages/ReviewSuccess.vue'], resolve)

const CompanyForm = resolve => require(['../pages/CompanyForm.vue'], resolve)
/**
 * ==================
 * 个人中心
 * ==================
 */
const CompanyManager = resolve => require(['../pages/CompanyManager.vue'], resolve)
const MyCustomers = resolve => require(['../pages/MyCustomers.vue'], resolve)
const CommissionPage = resolve => require(['../pages/CommissionPage.vue'], resolve)
const PersonalWrapper = resolve => require(['../components/PersonalWrapper.vue'], resolve)
const ServiceNode = resolve => require(['../pages/ServiceNode.vue'], resolve)
const CouponList = resolve => require(['../pages/CouponList.vue'], resolve)

const PersonalCenter = resolve => require(['../pages/PersonalCenter.vue'], resolve)
const AboutUs = resolve => require(['../pages/AboutUs.vue'], resolve)
const Recruitment = resolve => require(['../pages/Recruitment.vue'], resolve)
const NotFound = resolve => require(['../pages/NotFound.vue'], resolve)
const InvFin = resolve => require(['../pages/InvFin.vue'], resolve)
const ArticleHome = resolve => require(['../pages/ArticleHome.vue'], resolve)
const BrandQuery = resolve => require(['../pages/BrandQuery.vue'], resolve)
const Success = resolve => require(['../pages/Success.vue'], resolve)
const FcIntroduce = resolve => require(['../pages/FcIntroduce.vue'], resolve)
const ArticleList = resolve => require(['../pages/ArticleList.vue'], resolve)
const ArticleDetail = resolve => require(['../pages/ArticleDetail.vue'], resolve)
const AuthorDetail = resolve => require(['../pages/AuthorDetail.vue'], resolve)
const Login = resolve => require(['../pages/Login.vue'], resolve)
const Register = resolve => require(['../pages/Register.vue'], resolve)
const WxRedirect = resolve => require(['../pages/WxRedirect.vue'], resolve)
const TaxPlanning = resolve => require(['../pages/products/TaxPlanning.vue'], resolve)
const WxLogin = resolve => require(['../pages/WxLogin.vue'], resolve)
const Test = resolve => require(['../pages/Test.vue'], resolve)
const Search = resolve => require(['../components/Search.vue'], resolve)

// 活动页
const ActivityPage = resolve => require(['../pages/ActivityPage.vue'], resolve)
const CouponActivityPage = resolve => require(['../pages/CouponActivityPage.vue'], resolve)

import * as types from "../store/mutation-types"

const routes = [
  {
    path: '/',
    name: 'home-wapper',
    // redirect: '/home',
    component: HomeWrapper,
    // beforeEnter: handleHeader,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
      },
      {
        path: '/home',
        name: 'home',
        component: Home,
      },
      {
        path: '/activity',
        name: 'activity',
        component: ActivityPage,
        meta: {
          // noHeader: true,
        }
      },
      {
        path: '/coupon-activity',
        name: 'coupon-activity',
        component: CouponActivityPage,
        meta: {
          // noHeader: true,
        }
      },
      {
        path: '/search-result',
        name: 'search-result',
        component: SearchResultList,
        meta: {
          noHeader: true,
        }
      },
      {
        path: '/order/:orderSerialId/review',
        name: 'review',
        beforeEnter: requireAuth,
        component: Review
      },
      {
        path: '/review-success',
        name: 'review-success',
        beforeEnter: requireAuth,
        component: ReviewSuccess
      },
      {
        path: '/product-list/:cate1/:cate2?',
        name: 'product-list',
        component: ProductList,
        meta: {
          noHeader: true,
          title: '产品列表'
        }
      },
      {
        path: '/product/list/:cate1/:cate2?',
        name: 'product-list-old',
        component: ProductList,
        meta: {
          noHeader: true,
          title: '产品列表'
        }



      },

      {
        path: '/product-detail/:serialId',
        name: 'product-detail',
        component: ProductDetail
      },
      {
        path: '/product/detail/:serialId',
        name: 'product-detail-old',
        component: ProductDetail
      },
      {
        path: '/cart',
        name: 'cart',
        beforeEnter: requireAuth,
        component: MyCart,
        meta: {
          title: '企业湾-购物车'
        }
      },
      {
        path: '/pay',
        name: 'pay',
        beforeEnter: requireAuth,
        component: Pay,
        meta: {
          title: '企业湾-支付'
        }
      },
      {
        path: '/FcIntroduce',
        name: 'FcIntroduce',
        component: FcIntroduce
      },
      {
        path: '/about-us/:liName',
        name: 'about-us',
        component: AboutUs,
        meta: {
          title: '企业湾-关于我们'
        }
      },
      {
        path: '/recruitment',
        name: 'recruitment',
        component: Recruitment
      },
      {
        path: '/inv',
        component: InvFin
      },
      {
        path: '/brand',
        name: 'brand-query',
        component: BrandQuery
      },

      {
        path: '/checkout',
        name: 'checkout',
        beforeEnter: requireAuth,
        component: Checkout,
        meta: {
          noHeader: true,
          tinyTopBar: true,
          title: '企业湾-结算'
        }
      },
      {
        /**
         * 支付成功
         */
        path: '/success',
        name: 'success',
        component: Success,
        meta: {
          noHeader: true,
          tinyTopBar: true,
        }
      },
      // {
      //   path: '/404',
      //   name: 'not-found',
      //   component: NotFound
      // },

      // 有介绍的产品
      // {
      //   path: '/tax-planing',
      //   name: 'tax-planing',
      //   component: TaxPlanning,
      //   meta: {
      //     title: '企业湾-慧优税'
      //   }
      // },
      {
        path: '/company',
        name: 'company',
        component: CompanyForm,
        meta: {
          noHeader: true,
          tinyTopBar: true,
          title: '企业湾-公司管理'
        }
      },
    ]
  },

  /**
   * =========
   * 个人中心
   * =========
   */
  {
    path: '/p',
    name: 'p',
    component: PersonalWrapper,
    beforeEnter: requireAuth,
    children: [
      {
        path: '/person',
        name: 'person',
        component: PersonalCenter,
        meta: {
          title: '企业湾-个人中心'
        }
      },
      {
        path: '/order',
        name: 'order',
        component: OrderList,
        meta: {
          title: '企业湾-订单详情'
        }
      },
      {
        path: '/service',
        name: 'service',
        component: ServiceNode,
        meta: {
          title: '企业湾-服务节点'
        }
      },
      {
        path: '/coupon',
        name: 'coupon',
        component: CouponList,
        meta: {
          title: '企业湾-优惠券列表'
        }
      },
      {
        path: '/company-manager',
        name: 'company-manager',
        component: CompanyManager,
        meta: {
          title: '企业湾-公司管理'
        }
      },
      {
        path: '/commission',
        name: 'commission',
        component: CommissionPage
      },
      {
        path: '/customer',
        name: 'customer',
        component: MyCustomers,
        meta: {
          title: '我的客户'
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    // redirect:'http://127.0.0.1:8095?source=OFFICIAL',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: ResetPassword
  },
  // {
  // path: '/ArticleHome',
  // name: 'home',
  // component: ArticleHome,
  // children:[
  /**
   * =========
   * 文章中心
   * =========
   */
  {
    path: '/ArticleHome',
    component: ArticleHome,
    meta: {
      title: '企业湾-文章中心'
    }
  },
  {
    path: '/articles/list',
    name: 'article-list',
    component: ArticleList,
  },
  {
    path: '/articles/:id',
    name: 'article-detail',
    component: ArticleDetail
  },
  {
    path: '/author/:id',
    name: 'author',
    component: AuthorDetail
  },
  {
    path: '/wx-redirect',
    name: 'wx-redirect',
    component: WxRedirect
  },
  {
    path: '/wx-login',
    name: 'wx-login',
    component: WxLogin
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  },
  {
    path: '/s',
    name: 's',
    component: Search
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound
  },
  {
    path: '*',
    component: NotFound
  },
  // ]
  // },
]

let router = new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({y: 0}),
  routes: routes
});

let acctApi = process.env.ACCT_API

function requireAuth(to, from, next) {
  if (!store.getters.isLogin) {
    store.commit(types.REQUIRE_LOGIN)
    window.location.href = acctApi
  } else {
    next()
  }
  next()
}
/* global _czc */

import cookie from 'vue-cookie'
import trackApi from "../api/track";

router.afterEach((to, from) => {
  // debugger
  // traceYouMengAnalysis(to, from)

  traceShare(to)
  traceOrigin(to)
})


/**
 * 拦截路由， 如果路由中包含 '/#/xxx' 或 '/?#/xxx' (移动端路由格式) 去掉 #
 */
router.beforeEach((to, from, next) => {
  let fullPath = to.fullPath
  if (fullPath.startsWith('/#') || fullPath.startsWith('/?#')) {
    let path = fullPath.substring(fullPath.indexOf("#") + 1)
    next({path: path, query: to.query, params: to.params, meta: to.meta})
  }
  next()
})

/**
 * 友盟页面访问统计
 */
function traceYouMengAnalysis(to, from) {
  let path = `/#${to.path}`
  _czc.push(['_trackPageview', path, from.fullPath])
  console.log(`to.fullPath=${path}`)
}
/**
 * 统计 通过分享链接 访问页面
 * @param to
 */
function traceShare(to) {
  let shareId = to.query.shareId;
  if (shareId) {
    console.log(`shareId=${shareId}`)
    cookie.set('shareId', shareId, {expires: '1D', domain: 'www.qiyewan.com'})

    trackApi.pageVisited({
      path: to.path,
      shareId: shareId,
    })
  }
}

function traceOrigin(to) {
  let origin = to.query.origin
  if (origin) {
    console.log('[origin]', origin)

    cookie.set('origin', origin, {expires: '1D', domain: 'www.qiyewan.com'})

    trackApi.pageVisited({
      path: to.path,
      shareId: -1,
      origin: origin
    })
  }
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js